"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.login = login;exports.getInfo = getInfo;exports.logout = logout;exports.getMenuList = getMenuList;exports.getButtonPermissions = getButtonPermissions;
var _request = _interopRequireDefault(require("@/utils/request")); /* 用户相关api */

function login(data) {
  return (0, _request.default)({
    url: '/login',
    method: 'post',
    data: data });

}

function getInfo(token) {
  return (0, _request.default)({
    url: '/user/info',
    method: 'get',
    params: { token: token } });

}

function logout() {
  return (0, _request.default)({
    url: '/logout',
    method: 'get' });

}

// 获取菜单列表
function getMenuList() {
  return (0, _request.default)({
    url: '/api/menu/left',
    method: 'get' });

}

// 获取按钮权限列表
function getButtonPermissions() {
  return (0, _request.default)({
    url: '/api/menu/button/pers',
    method: 'get' });

}